<template>
    <career-youth-programs-template-page hero-title="Учеба<br>или карьера?" />
</template>

<script setup>
import CareerYouthProgramsTemplatePage from './template/CareerYouthProgramsTemplatePage.vue'
</script>

<style lang="scss">
</style>
